/*=========================================================================================
  File Name: moduleCompanyMutations.js
  Description: Company Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_COMPANY(state, item) {
		state.companies.unshift(item);
	},
	SET_COMPANIES(state, companies) {
		state.companies = companies || [];
	},
	// SET_LABELS(state, labels) {
	//   state.eventLabels = labels
	// },
	UPDATE_COMPANY(state, product) {
		const productIndex = state.companies.findIndex((p) => p.id === product.id);
		Object.assign(state.companies[productIndex], product);
	},
	REMOVE_COMPANY(state, itemId) {
		const ItemIndex = state.companies.findIndex((p) => p.config_company_id === itemId);
		state.companies.splice(ItemIndex, 1);
	},
	SET_CONFIG_LIST(state, data) {
		state.config_list = data || [];
	},
	DONT_ASKME_AGAING(state, val) {
		state.dont_ask_me_again = val;
	},
	TOGGLE_ROUTING_TYPE_DROP_DOWN(state, val) {
		state.routing_type_drop_down = val;
	},
};
